import { ReactNode } from "react";

export function activeStatusPipe(status: boolean):ReactNode {
    if (status) return <p className="text-green-500">Hoạt động</p>
    return <p className="text-red-600">Chưa kích hoạt</p>
}